import React from "react";
import classNames from "classnames";
import {useSelector} from "react-redux";
import styled from "styled-components";

import TopNav from "../components/Navbar";
import Menu from "../components/Menu";

export const LayoutNavbarMenu = ({className, children}) => {
	const menu = useSelector(({menu}) => menu);
	const app = useSelector(({app}) => app);

	return (
		<div
			id={'app-container'}
			className={classNames(className, {
				'menu-visible': menu.visible || !app.isMobile,
			})}
		>
			<TopNav/>
			<Menu/>
			<main>
				<div className={`container-fluid`}>
					<div className={'layout-menu'} id={'app'}>
						{children}
					</div>
				</div>
			</main>
		</div>
	);
};

export const LayoutNavbar = ({className, children}) => {
	return (
		<div
			id={'app-container'}
			className={classNames(className, 'menu-hidden')}
		>
			<TopNav/>
			<main>
				<div className={`container-fluid`}>
					<div className={'layout-menu'} id={'app'}>
						{children}
					</div>
				</div>
			</main>
		</div>
	);
};

export const LayoutFullScreen = ({className, children}) => {
	return (
		<div style={{
			position: 'fixed',
			top: 0,
			left: 0,
			right: 0,
			bottom: 0,
			width: '100%',
			height: '100%',
		}}>
			<div id="app-container" className="h-100">
				{children}
			</div>
		</div>
	);
};
